<template>
  <div class="block-title-box">
    <div class="title" :style="{color: whiteColor ? '#fff':'#000'}">
      <span>{{title}}</span>
    </div>
    <div class="more">
      <div class="line" :style="{borderBottom: whiteColor ? borderWidth+'px solid #FFF' : borderWidth+'px solid #014289'}"></div>
      <div class="text" :style="{color: whiteColor ? '#fff' : '#014289'}" @click="handleMore">更多</div>
      <div class="line" :style="{borderBottom: whiteColor ? borderWidth+'px solid #FFF' : borderWidth+'px solid #014289'}"></div>
    </div>
  </div>
</template>

<script>
  export default {
    components: { },
    props: {
      title: null,
      whiteColor: false,      
      
      channelAlias: null,
    },
    data() {
        return {
          borderWidth: 2,
        };
      },
    methods: {
      handleMore(){
        this.$router.push(
            {
              path: '/' + this.channelAlias,              
            }
          );       
      },

      onResize(){
        let screenW = document.documentElement.clientWidth;
        if(screenW < 600){
          this.borderWidth = 1;
        }else{
          this.borderWidth = 2;
        }
      }
    },
    created() {
      window.addEventListener('resize', this.onResize);
    },
    destroyed(){
      window.removeEventListener('resize', this.onResize);
    },
    mounted(){
      this.$nextTick(()=>{
          this.onResize();
      });
    },
  };
</script>

<style scoped>

.block-title-box{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  /*gap: 16px;*/
}

.block-title-box .title{
  font-size: 48px;
  font-weight: bold;
  line-height: 48px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 16px;
}

.block-title-box .more{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px;
  /*gap: 16px;*/
}

.block-title-box .line{
  width: 60px;
  height: 0px;
  line-height:0px;
  overflow: hidden;
}
.block-title-box .text{
  font-size: 20px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  cursor: pointer;
  margin:0px 16px;
}
.block-title-box .text:hover{
  opacity: 0.8;
}

@media screen and (max-width: 960px) {
  .block-title-box .title{
    font-size: 36px;
    line-height: 36px;
  }
  /*
  .block-title-box{
    gap: 10px;
  }
  */
  .block-title-box .more{
    gap: 10px;
  }
  .block-title-box .text{
    font-size: 14px;
    margin: 0px 10px;
  }
  .block-title-box .line{
    width: 30px;    
  }
}
@media screen and (max-width: 600px) {  
  /*
  .block-title-box{
    gap: 5px;
  }
  */
  .block-title-box .title{
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/blocktitle/index.vue